<template>
  <div class="d-flex justify-content-center body-content confirmation-wrapper">
    <div class="text-center confirmation-content">
      <p class="font-28 mb-8 font-weight-bold">
        認証が完了しました！
      </p>
      <div class="image-container mb-5">
        <img :src="successImage" alt="Success" class="success-image" />
      </div>
      <p class="font-16 mb-4 font-weight-bold desktop-text">
        「Bloomキャリア登録」を利用する大手企業各社へ登録が可能です<br />
        登録可能企業を次の画面でご確認ください
      </p>
      <p class="font-16 mb-4 font-weight-bold mobile-text">
        Bloomキャリア登録を利用する<br />
        大手企業各社へ追加登録が可能です
      </p>
      <button
        class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
        @click="handleOkClick"
        :style="buttonStyle"
      >
        次へ（登録可能企業を表示）
      </button>
    </div>
  </div>
</template>

<script>
import successImage from '../assets/Group300.png';

export default {
  name: 'ConfirmationPage',
  data() {
    return {
      successImage: successImage
    };
  },
  props: {
    buttonStyle: {
      type: Object,
      default: () => ({
        background: 'red',
        'border-color': 'red'
      })
    }
  },
  methods: {
    handleOkClick() {
      this.$emit('ok-clicked');
    }
  }
};
</script>

<style scoped>
.confirmation-wrapper {
  padding-top: 6rem;
}

.confirmation-content {
  max-width: 500px;
  width: 100%;
}

.btn-cstm {
  padding: 15px 20px;
  width: 343px;
  border-radius: 3px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
  background-color: #076d6c !important;
  border-color: #076d6c !important;
}

.font-28 {
  font-size: 28px;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

.mb-6 {
  margin-bottom: 3rem !important;
}

.mb-8 {
  margin-bottom: 8rem !important;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.success-image {
  max-width: 250px;
  width: 100%;
  height: auto;
}

.desktop-text {
  display: block;
}

.mobile-text {
  display: none;
}

@media (max-width: 768px) {
  .confirmation-wrapper {
  }
  
  .font-28 {
    font-size: 24px;
    margin-bottom: 3rem !important;
  }
  
  .success-image {
    display: none;
  }
  
  .image-container {
    display: none;
  }
  
  .desktop-text {
    display: none;
  }
  
  .mobile-text {
    display: block;
    margin-bottom: 10rem !important;
  }
  
  .btn-cstm {
    margin-top: 0 !important;
  }
}
</style> 